import React from 'react';
import Loader from './Loader';

/**
 * Kept as its own export because several pages import this name, but it is
 * now the same component as `Loader`. The two had drifted into separate
 * copies of the same overlay with different spinner colours; there is one
 * implementation now, in Loader.
 */
const SpinLoader: React.FC = () => <Loader />;

export default SpinLoader;
